import * as PAGINATION from 'constant/pagination'
import * as ACTIONS from 'constant/action/user'
import * as AUTH_ACTION from 'constant/action/auth'
import * as LOADER_ACTIONS from 'constant/action/loader'
import * as NUMBER from 'constant/number'
import * as TABLE from 'constant/table'
import { createAction } from 'redux-actions'
import _ from 'lodash'
import { updateLoading } from './loader'

const updateUsers = createAction(ACTIONS.UPDATE_USERS)
const updateAllUsers = createAction(ACTIONS.UPDATE_ALL_USERS)
const updatePagination = createAction(ACTIONS.UPDATE_USER_PAGINATION)
const updateUserTypes = createAction(ACTIONS.UPDATE_USER_TYPES)
const updateUserSubmitting = createAction(LOADER_ACTIONS.UPDATE_USER_SUBMITTING)
const updateUser = createAction(AUTH_ACTION.UPDATE_AUTH_STATE)

export const getUsers = (sort = PAGINATION.SORT.USER, direction = PAGINATION.ACENDING, start) => async (dispatch, getState, { user }) => {
  dispatch(updateLoading(true))
  dispatch(updatePagination({
    direction,
    sort,
    start
  }))

  const {
    user: userState
  } = getState()

  const users = await user.getUsers(sort, direction, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(userState, 'users.start'))

  dispatch(updateUsers(users))
  dispatch(updateLoading(false))
}

export const getAllUsers = () => async (dispatch, getState, { user }) => {
  const users = await user.getAllUsers()
  dispatch(updateAllUsers(users))
}

export const changeUserStatus = (uuid) => async (dispatch, getState, { user }) => {
  await user.changeUserStatus(uuid)
  dispatch(getUsers())
}

export const deleteUser = (uuid) => async (dispatch, getState, { user }) => {
  await user.deleteUser(uuid)
  dispatch(getUsers())
}

export const editUser = (userObject) => async (dispatch, getState, { user }) => {
  try {
    dispatch(updateUserSubmitting(true))
    await user.editUser(userObject)
    dispatch(updateUserSubmitting(false))
    dispatch(getUsers())
    return userObject
  } catch (error) {
    dispatch(updateUserSubmitting(false))
    return { error: true, message: error.message }
  }
}

export const addNewUser = (userObject) => async (dispatch, getState, { user }) => {
  try {
    dispatch(updateUserSubmitting(true))
    await user.addUser(userObject)
    dispatch(updateUserSubmitting(false))
    dispatch(getUsers())
    return userObject
  } catch (error) {
    dispatch(updateUserSubmitting(false))
    return { error: true, message: error.message }
  }
}

export const searchUser = (searchTerm, sort = PAGINATION.SORT.USER, direction = PAGINATION.ACENDING, start = NUMBER.ZERO) => async (dispatch, getState, { user }) => {
  dispatch(updateLoading(true))
  dispatch(updatePagination({
    direction,
    sort,
    start
  }))

  const {
    user: userState
  } = getState()
  const response = await user.searchUser(searchTerm, sort, direction, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(userState, 'users.start'))
  dispatch(updateUsers(response))
  dispatch(updateLoading(false))
}

export const getUserTypes = (exception = null) => async (dispatch, getState, { user }) => {
  const userTypes = await user.getUserTypes(exception)
  dispatch(updateUserTypes(userTypes))
}

export const updateEmailPreference = (email, userUuid) => async (dispatch, getState, { user }) => {
  dispatch(updateLoading(true))
  const [userObj] = await user.updateEmailPreference(email, userUuid)
  dispatch(updateUser({ user: userObj }))
  dispatch(updateLoading(false))
}

export const updateLocationPreference = (preference, userUuid) => async (dispatch, getState, { user }) => {
  try {
    const [userObj] = await user.updateLocationPreference(preference, userUuid)
    dispatch(updateUser({ user: userObj }))
  } catch (error) {
    console.error(error)
  }
}

export const updateTC = (preference) => async (dispatch, getState, { user }) => {
  try {
    const {
      auth: {
        user: userState
      }
    } = getState()
    const [userObj] = await user.updateTC(preference, userState.uuid)

    dispatch(updateUser({ user: userObj }))
  } catch (error) {
    console.error(error)
  }
}
